import React from "react";
import ResetProgressSvg from "@/assets/icons/reset.svg?react";

interface ResetProgressIconProps {
  size?: "xs" | "sm" | "md" | "lg";
  color?: string;
  className?: string;
}

const ResetProgressIcon: React.FC<ResetProgressIconProps> = ({
                                                               size = "md",
                                                               color = "currentColor",
                                                               className = "",
                                                             }) => {
  const sizeClasses = {
    xs: "w-4 h-4",
    sm: "w-5 h-5",
    md: "w-6 h-6",
    lg: "w-7 h-7",
  };

  return (
    <ResetProgressSvg
      stroke={color}
      className={`${sizeClasses[size]} ${className}`}
    />
  );
};

export default ResetProgressIcon;